import {useMutation} from '@apollo/react-hooks';

import type {
    DiscardChanges as DiscardChangesMutation,
    DiscardChangesVariables as DiscardChangesMutationVariables,
} from 'nutshell-graphql-types';

import DISCARD_CHANGES from '../mutations/discard-changes.graphql';

export function useDiscardChanges(): {
    discardChanges: (pageId: string) => Promise<any>;
} {
    const [pageDiscardChanges] = useMutation<
        DiscardChangesMutation,
        DiscardChangesMutationVariables
    >(DISCARD_CHANGES);

    return {
        discardChanges: (pageId: string) =>
            pageDiscardChanges({
                variables: {input: {pageId}},
            }),
    };
}
